import React, { useCallback } from "react";

import type { ISession } from "@mne-authentication/api";
import { hasPermission } from "@mne-authentication/api/currentuser";
import { Session } from "@mne-authentication/session2";

export interface ISessionProps {
  session: ISession;
  loading: boolean;
  checkPermission(opts: { customerId?: number; name: string }): Promise<boolean>;
}
export interface IApplicationSessionProps {
  apiUrl: string;
  session: ISession;
  children: React.ReactNode;
}

export function ApplicationSession({ children, apiUrl, session }: IApplicationSessionProps) {
  const checkPermission = useCallback(
    ({ customerId, name }): Promise<boolean> => {
      if (!session) {
        return Promise.reject("No session available");
      }

      if (!customerId) {
        return Promise.resolve(session.functions.some((func) => func.name === name));
      }

      return hasPermission(name, customerId, { apiUrl }).then(({ response }) => Boolean(response.ok));
    },
    [session, apiUrl],
  );
  return (
    <Session
      {...{
        checkPermission,
        loading: false,
        session,
      }}
    >
      {children}
    </Session>
  );
}
